import {BaseFormModel} from './base-form-model';
import {Sortable} from './sortable';
import {MenuItem} from './menu-item';
import {MenuItemPrice} from './menu-item-price';
import {OrderItemModifier} from './order-item-modifier';

export class MenuSelectionItem extends BaseFormModel<MenuSelectionItem> implements Sortable {
    id: number;
    sortOrder: number;
    menuItem: MenuItem;
    additionalPrice: number;
    printForDefault: boolean;
    defaultSelection: boolean;
    preventNestedSelection: boolean;
    priceFromItem: boolean;
    menuItemPrice: MenuItemPrice;

    // for user menu management
    selected: boolean;
    selectionCount: number;
    modifiers: OrderItemModifier[];
    removed = false;

    name: string;

    init(): void {
        this.menuItem = new MenuItem(this.menuItem);
    }

    getName() {
        return !!this.menuItem ? this.menuItem.name : this.name;
    }

    isVariable(): boolean {
        return !!this.menuItem && this.menuItem.isVariable();
    }

    deposit(): number {
        return this.menuItem.deposit();
    }
}
